export default function DateChange(data) {
  if (data) {
    return `${new Date(data).toLocaleString().split(',')[0]}
  
    ${new Date(data).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })}`;
  } else return '';
}

export function dateChange2(data) {
  if (!data) return '';
  return (
    new Date(data).toLocaleString().split(',')[0] +
    ' ' +
    new Date(data).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
  );
}

export function dateChangeWithSeconds(data) {
  if (!data) return '';
  return (
    new Date(data).toLocaleString().split(',')[0] +
    ' ' +
    new Date(data).toLocaleTimeString('en-US', {
      second: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
  );
}
